import { createFileRoute } from "@tanstack/react-router";
import { CaseStudyDetailView } from "@/components/archive/CaseStudyDetailView";

export const Route = createFileRoute("/_authenticated/dashboard/case-studies/$id")({
  head: () => ({ meta: [{ title: "Case Study Replay | Member Desk" }, { name: "robots", content: "noindex" }] }),
  component: MemberCaseStudy,
});

function MemberCaseStudy() {
  const { id } = Route.useParams();
  return <CaseStudyDetailView id={id} member />;
}
